var lib_core           = require("lib-core");
var lib_geometry       = require("lib-geometry");
var ui_extensions      = require("ui-extensions");
var cio_config = require("cio-config");
var InspectorInputType = require("./inspectorInputType.js");


var InspectorView = function (model, stateMachine, editorModel, editorView, events, config) {
    var self = this;
    ui_extensions.AbstractUIView.apply(this, arguments);

    this.model = model;
    this.stateMachine = stateMachine;
    this.editorModel = editorModel;
    this.editorView = editorView;
    this.elements = [];
    this.events = events;
    this.config = config;

    this.model.visible.onChange('inspectorVisible', function(value) {
        self.editorView.heavyHandler.scheduleHeavy('inspector_shown', self.hideOrShow, self, [value], self);
    },10);

    if (this.editorModel.canvasRect) {
        this.editorModel.canvasRect.onChange(this, function(){
            self.defaultInspectorPosition();
        });
    }

    self.editorView.heavyHandler.scheduleHeavy('inspector_shown', self.hideOrShow, self, [this.model.visible()], self);

};

lib_core.inherit(InspectorView, ui_extensions.AbstractUIView);

module.exports = InspectorView;


InspectorView.prototype.hideOrShow = function(visible) {
    if (!visible) {
        this.hide();
    } else {
        var inspectorSubjects = this.model.inspectorSubjectModel.getInspectorSubjects();
        var inspectorSubelementSubject = this.model.inspectorSubjectModel.getInspectorSubelementSubject();

        if (inspectorSubjects.size() == 0 /*nothing to show*/|| inspectorSubjects.size() > 1 /*don't show inspector if multiple elements selected*/) {
            this.hide();
        } else {    //show inspector
            var inspectorElements = this.getInspectorElements(inspectorSubjects, inspectorSubelementSubject);
            this.buildAndShow(inspectorElements.input_elements, inspectorElements.help_elements);
        }
    }
};

InspectorView.prototype.getTemplate = function () {
    if(!this._template){
        this._template = this.editorView.getTemplate().addInspector(this.inspectorMetaName, this.config.theme);
        this.defaultInspectorPosition();
        if(this.model.draggable()) {
            this.attachDraggingListeners(this.editorView);
        }
        if(this.config.invertedTitle) this._template.setInvertedHeader();
    }
    return this._template;
};

InspectorView.prototype.buildAndShow = function (elements, metaInfo) {
    this.build(elements, metaInfo, this.getTemplate());
    this.show();
};

InspectorView.prototype.show = function () {
    this.getTemplate().show();
};

InspectorView.prototype.hide = function () {    //destroyer
    var self = this;
    this.elements.forEach(function (element) {  //'brute force' way to clean up all handlers that may have been set
        self.lines.forEach(function(line) {
            if(element.visible) element.visible.removeHandlers(line);
            if(element.datamember) element.datamember.removeHandlers(line);
            if(element.unitmember && element.unitmember.removeHandlers) element.unitmember.removeHandlers(line);
            if(element.list_ && element.list_.removeHandlers) element.list_.removeHandlers(line);
        });
        element.remove();
    });
    this.elements = [];
    this.getTemplate().hide();
};

InspectorView.prototype.defaultInspectorPosition = function(){
    var padding = 10;
    var inspectorWidth = this.getTemplate().getWidth();
    var inspectorOffsetX = 0;
    var editorWidth = this.editorModel.canvasRect().width;

    if(this.model.location() == "top left") {
        inspectorOffsetX = padding;
    }else{
        inspectorOffsetX = editorWidth - inspectorWidth - padding;
    }

    this.model.position(new lib_geometry.Coord(inspectorOffsetX, padding));
};

InspectorView.prototype.getEmptyInspectorElements = function() {
    return {help_elements:{name:"Empty"}, input_elements:[]};
};

InspectorView.prototype.getInspectorElements = function(inspectorSubjects, inspectorSubelementSubject) {
    console.assert(inspectorSubjects.size() > 0);
    var inspectorSubject = inspectorSubjects.getOne();
    var self = this;
    var inspectorElements = self.getEmptyInspectorElements();

    if (inspectorSubject.getInspectorElements) {
        inspectorElements = inspectorSubject.getInspectorElements(this.model.readOnly());
    }

    //we show the inspector for the overall shape with the subelement inspector element shown first (planned to change)
    if(inspectorSubelementSubject) {
        if(inspectorSubelementSubject.getInspectorElements) {
            var selectedSubElementInspectorElements = inspectorSubelementSubject.getInspectorElements(this.model.readOnly());
            inspectorElements.input_elements = selectedSubElementInspectorElements.input_elements.concat(inspectorElements.input_elements);
        }
    }
    return inspectorElements;
};

InspectorView.prototype.build = function (elements, metaInfo, template, readOnlyMode) {
    var self = this;

    // clear inspector
    template.clear();

    // set title
    if(metaInfo) {
        // get inspector name
        if('name' in metaInfo) {
            if(template.setTitle) template.setTitle(metaInfo.name);
        }
    }

    // create new group
    var inspectorGroup = template.addGroup();

    this.addElements(elements, inspectorGroup, readOnlyMode);
};


InspectorView.prototype.getUnitFromList = function(unitClass, stringList) {
    var names = unitClass.getNames();
    for(var i = 0; i < stringList.length; i++){
        for(var j = 0; j < names.length; j++){
            if(stringList[i] == names[j]){
                return stringList[i];
            }
        }
    }
    return null;
}


InspectorView.prototype.addElements = function(elements, target, readOnlyMode) {
    var self = this;

    // this function adds interaction to the current inspectorLine
    function addInteractionTextField(line, datamember, unitmember, datatype, other_units, updateWhileTyping, readOnly, disabled) {

        if(disabled) {
            $('.js-inspector__textinput__value', line.$el).addClass('editor__inspector__item__textinput--disabled');
            $('.js-inspector__textinput__value', line.$el).prop("disabled", true);

            return;
        }

        datatype = datatype || cio_config.types.any;

        if(readOnly) {
            $('.js-inspector__textinput__value', line.$el).addClass('editor__inspector__item__textinput--readonly');
            $('.js-inspector__textinput__value', line.$el).attr("readonly", true);
        }

         // In the new text boxes, we should kill the event and turn it into an SM event
         //  if the user is attempting editor hotkeys, not text field input.
         //   we decide that is the case if the meta button is down.
        $('.js-inspector__textinput__value', self.$el).unbind('keydown').bind('keydown', function (event) {
             // PS if the hotkey is one that we do allow (like page reload) preform no interferance
            if((event.altKey == true || event.metaKey == true) && !self.editorView.isAllowedBrowserEvent(event))
                self.editorView.turnDocumnetEventIntoSMEvent(event, lib_core.GuiEvents.GUI_KEY_PRESSED);
        });

        $('.js-inspector__textinput__value', self.$el).unbind('keyup').bind('keyup', function (event) {
            if((event.altKey == true || event.metaKey == true) && !self.editorView.isAllowedBrowserEvent(event))
                self.editorView.turnDocumnetEventIntoSMEvent(event, lib_core.GuiEvents.GUI_KEY_RELEASED);
        });

        // fire statemachine
        line.$el.on('Cioui:Inspector:value', function (e, value) {
            //////// UNIT CASE 1: if we have a dropdown style unit
            if(other_units.length > 0){

                // parse for unit and set the dropdown to the given unit
                var hasUnit = cio_config.UnitConversions.hasUnit(value);
                if(hasUnit){
                    var inUnit = cio_config.UnitConversions.parseUnit(value);
                    if(inUnit) {
                        var unitString = self.getUnitFromList(inUnit, other_units);
                        if( unitString ){
                            // set, and trim so below parse works
                            var parsedUnit = unitString;
                            // NOTE this is not sufficient if (when) the unit becomes a part of the datamodel.
                            value = cio_config.UnitConversions.trimUnit(value);
                        }
                    }
                }
                var parsedVal  = datatype.reader(value);

            //// UNIT CASE 2 defined unit or no unit (but we have a reader)
            } else if( datatype.reader ) {
                // if there is a unit, parse and possibly convert
                if(unitmember){
                    var parsedVal = datatype.reader(value, unitmember());

                } else { // no specefied unit.  do not accept units, will not covert.
                    var parsedVal = datatype.reader(value);
                }

            //// UNIT CASE 3 (some type without a reader, just parse) (( does this exist?)) yes, strings / objects / bool (things that can never have units)
            } else {
                var parsedVal = datatype.parser(value);
            }

            ///// based on what parsedVal ends up as in the logic above, decide wheter to set or error:
            if(isValid(parsedVal)){

                line.$el.removeClass("editor__inspector__item__error");

                var cEvent = new lib_core.GuiEvent(self.events.changeProperty, datamember.getTreeNode())
                .scope(self.model.scope())
                .data('id', datamember.getName())
                .data('value', parsedVal)
                .data('delayChangeProperty', !updateWhileTyping);
                self.stateMachine.handle(cEvent);

            } else {

                line.$el.addClass("editor__inspector__item__error");

                var cEvent = new lib_core.GuiEvent(self.events.changeProperty, datamember.getTreeNode())
                .scope(self.model.scope())
                .data('id', datamember.getName())
                .data('value', datamember())
                .data('delayChangeProperty', !updateWhileTyping);
                self.stateMachine.handle(cEvent);
            }

            if(parsedUnit){
                // the below will work even if unit is a string, since i turn it into a simple return only function.
                //   in that case it will just not do anything
                unitmember( parsedUnit );

                // A note about this, It will need to be fixed it we want to ever save the unitmember in the datamodel.
                // in that case, setting data cannot be done like above.  We need to go throught the state machine and
                // start/stop the recorder.  The reason that is difficult is because it has to be done in one event
                // (or else we hit the two events at the same time problem) and as of right now, only one node
                // can be passed in with an event to be changed.  With the new unit system, the unitmember
                // and the datamember will not live in the same place, so we need a way to pass in and change
                // two different nodes with one event.  Once I hit that problem I postproned this task for now
                // (also not that this is a problem that needs to get solved with the unit dropdowns too, so no new problem is being created here)
            }
        });

        line.$el.on('Cioui:Inspector:enter', function (e, value) {
            var cEvent = new lib_core.GuiEvent(self.events.enter)
                .scope(self.model.scope());
            self.stateMachine.handle(cEvent);
        });

        line.$el.on('Cioui:Inspector:focus', function (e, value) {
            var cEvent = new lib_core.GuiEvent(self.events.focus)
                .scope(self.model.scope());
            return self.stateMachine.handle(cEvent);
        });

        line.$el.on('Cioui:Inspector:blur', function (e, value) {
            var cEvent = new lib_core.GuiEvent(self.events.blur)
                .scope(self.model.scope());
            return self.stateMachine.handle(cEvent);
        });

        //jquery.inputmask to force the user to enter acceptable values
        var text_field = $('.js-inspector__textinput__value', line.$el);
        var formatter = function(val) {return val;};
        if (datatype === cio_config.types.float) {
           // text_field.inputmask({alias:"numeric", positionCaretOnTab: false});
            formatter = floatFormatter;
        } else if (datatype === cio_config.types.positive_float) {
           // text_field.inputmask({alias:"numeric", allowMinus: false, positionCaretOnTab: false});
            formatter = floatFormatter;
        } else if (datatype === cio_config.types.int || datatype === cio_config.types.positive_int) {
           // text_field.inputmask({alias:"integer", positionCaretOnTab: false});
        } else if (datatype === cio_config.types.string || datatype === cio_config.types.any) {
            0;//nothing
        } else {
            console.error("unknown type");
        }

        var attachedUnitMem = (other_units.length > 0)? null: unitmember;

        //reset correct value when focus lost
        line.$el.on('Cioui:Inspector:blur', function () {
            line.setValue(formatter(datamember(), attachedUnitMem));
            line.$el.removeClass("editor__inspector__item__error");
        });

        line.$el.on('Cioui:Inspector:enter', function () {
            line.setValue(formatter(datamember(), attachedUnitMem));
            line.$el.removeClass("editor__inspector__item__error");
        });

        //reset when change detected
        datamember.onChange(line, function () {
            if (!$('.js-inspector__textinput__value', line.$el).is(":focus")) {
                line.setValue(formatter(this(), attachedUnitMem));
            }
            line.$el.removeClass("editor__inspector__item__error");
        }, 10);

        //visually warn about unacceptable value
        if (datamember.onSetFail) {
            datamember.onSetFail(line, function () {
                line.$el.addClass("editor__inspector__item__error");
            }, 10);
        }

        //visually remove unacceptable value warn
        if (datamember.onSetPass) {
            datamember.onSetPass(line, function () {
                line.$el.removeClass("editor__inspector__item__error");
            }, 10);
        }

        line.setValue(formatter(datamember(), attachedUnitMem));
    }

    // this function adds interaction to the current inspectorLine
    function addInteraction(line, datamember, eventType) {
        // fire statemachine
        line.$el.on(eventType, function (e, value) {
            var cEvent = new lib_core.GuiEvent(self.events.changeProperty, datamember.getTreeNode())
                .scope(self.model.scope())
                .data('id', datamember.getName())
                .data('value', value);
            self.stateMachine.handle(cEvent);
        });

        if (line.setValue && eventType == 'Cioui:Inspector:value')
            line.setValue(datamember());
        if (line.setBoolean && eventType == 'Cioui:Inspector:boolean')
            line.setBoolean(datamember());
        if (line.setUnit && eventType == 'Cioui:Inspector:unit')
            line.setUnit(datamember());

        //reset when change detected
        if(datamember.onChange){
            datamember.onChange(line, function () {
                if (line.setValue && eventType == 'Cioui:Inspector:value')
                    line.setValue(datamember());
                if (line.setBoolean && eventType == 'Cioui:Inspector:boolean')
                    line.setBoolean(datamember());
                if (line.setUnit && eventType == 'Cioui:Inspector:unit')
                    line.setUnit(datamember());
            }, 10);
        }
    }

    function addInteractionImage(image, value, datamember) {
        image.$el.on('Cioui:Inspector:click', function(e) {
            var cEvent = new lib_core.GuiEvent(self.events.changeProperty, datamember.getTreeNode())
                        .scope(self.model.scope())
                        .data('id', datamember.getName())
                        .data('value', value);

            self.stateMachine.handle(cEvent);
        });

        if(datamember.onChange) {
            datamember.onChange(image, function() {
                if(value === datamember()) {
                    image.select();
                } else {
                    image.deselect();
                }
            });
        }
    }

    // this functions adds a button element into the target
    function addButton(target, element) {
        var button = target.addButton(element.label, element.icon, element.tooltip);
        button.$el.on('Cioui:Inspector:click', function(e){
            if(element.cEvent instanceof Array) {
                // need to send events for each selected object in list
                $.each(element.cEvent, function(elInd, val) {
                    self.stateMachine.handle(val);
                });
                return false;

            } else {
                return self.stateMachine.handle(element.cEvent);
            }
        });

        if(element.isToggleButton && element.isActive) {
            function changeActiveStatus(state) {
                if(state) {
                    button.setActive();
                } else {
                    button.setInActive();
                }
            }

            element.isActive.onChange(button, function(val) {
                changeActiveStatus(val);
            });

            changeActiveStatus(element.isActive());
        }

        if(element.isDisabled) {
            function changeEnableStatus(state) {
                if(state) {
                    button.disable();
                } else {
                    button.enable();
                }
            }

            element.isDisabled.onChange(button, function(val) {
                changeEnableStatus(val);
            });

            changeEnableStatus(element.isDisabled());
        }

        return button;
    }

    function connectSelectboxOptions(line, element) {
        function setOptions() {
            line.clearOptions();
            line.addOptions(element.list_() || []);
            line.setValue(element.init);
        }
        element.list_.onChange(line, setOptions);
        setOptions();
    }

    function connectSelectboxEvent(line, element) {
        line.$el.on('Cioui:Inspector:value', function (e, value) {
            if(element.cEvent instanceof Array) {
                $.each(element.cEvent, function(elInd, e) {
                    var cEvent = e.data('value', value);
                    self.stateMachine.handle(cEvent);
                });
                return false;
            } else {
                var cEvent = element.cEvent.data('value', value);
                return self.stateMachine.handle(cEvent);
            }
        });
    }

    function connectVisibility(line, element) {
        function changeVisibility() {
            if(element.visible())
                line.$el.css("display", "");
            else
                line.$el.css("display", "none");
        }
        element.visible.onChange(line, changeVisibility);
        changeVisibility();
    }

    elements = elements.map(function(element) {
        return InspectorInputType.convert(element);
    });
    this.elements = elements;
    this.lines = [];

    elements.forEach(function (element) {
        var readOnly = readOnlyMode || element.read_only || self.model.readOnly();
        var disabled = element.disabled || false;

        if(element) {
            var label = element.label;
            var type = element.type;
            var tooltip = element.tooltip;

            var datamember = element.datamember;
            var value = element.value;
            if (datamember) {
                value = datamember();
            }

            // hack for both unit types to work without having to change
            // every file
            var unitmember = element.unit;
            if(element.unitmember) unitmember = element.unitmember;
            if(typeof unitmember == "string"){
                 var unit = unitmember;
                 var unitmember = function(){
                       return unit;
                 }
            }

            var checkmember = element.checkmember;

            switch (type) {
                case InspectorInputType.IMAGE:
                    var image = target.addImage(label, element.image, tooltip);
                    connectVisibility(image, element);
                    self.lines.push(image);
                    break;

                case InspectorInputType.SELECTABLE_IMAGE_GROUP:
                    var selectableImageGroup = target.addSelectableImageGroup(label, tooltip, readOnly);
                    connectVisibility(selectableImageGroup, element);

                    if(element.images) {
                        element.images.forEach(function(imageElement) {
                            var image = selectableImageGroup.addImage(imageElement.label, imageElement.image, imageElement.tooltip);

                            if(imageElement.selected) {
                                image.select();
                            }

                            console.assert(datamember, "Datamember is missing for selectable image group inspector element.")
                            addInteractionImage(image, imageElement.data, datamember);
                        });
                    }

                    self.lines.push(selectableImageGroup);
                    break;

                case InspectorInputType.SPINNER:
                    var spinner = target.addSpinner(label);
                    connectVisibility(spinner, element);
                    self.lines.push(spinner);
                    break;
                case InspectorInputType.LABEL:
                    if(!element.hiddenInReadOnlyMode || !readOnly) {
                        var label = target.addLabel(label, tooltip);
                        self.lines.push(label);
                    }
                    break;
                case InspectorInputType.TEXT:
                    var textinput = target.addTextInput(label, "", tooltip);
                    addInteractionTextField(textinput, datamember, unitmember, element.datatype, [] , element.update_while_typing, readOnly, disabled);
                    connectVisibility(textinput, element);
                    self.lines.push(textinput);
                    break;

                case InspectorInputType.READ_ONLY:
                    var readonly = target.addReadOnly(label, value, tooltip);
                    connectVisibility(readonly, element);
                    datamember.onChange(readonly, function () {
                        readonly.setValue(datamember());
                    });
                    self.lines.push(readonly);
                    break;

                case InspectorInputType.VALUE_AND_UNIT:
                    var valueunit = target.addValueUnit(label, "", element.allowed_units, tooltip);
                    connectVisibility(valueunit, element);
                    addInteractionTextField(valueunit, datamember, unitmember, element.datatype,  element.allowed_units, element.update_while_typing, readOnly, disabled);
                    valueunit.setUnit(unitmember());
                    addInteraction(valueunit, unitmember, 'Cioui:Inspector:unit');
                    self.lines.push(valueunit);
                    break;

                case InspectorInputType.VALUE_UNIT_CHECK:
                    var valueunitcheck = target.addValueUnitCheck(label, "", element.allowed_units, checkmember, tooltip);
                    connectVisibility(valueunitcheck, element);
                    addInteractionTextField(valueunitcheck, datamember, unitmember, element.datatype, element.allowed_units, element.update_while_typing, readOnly, disabled);
                    valueunitcheck.setUnit(unitmember());
                    addInteraction(valueunitcheck, unitmember, 'Cioui:Inspector:unit');
                    addInteraction(valueunitcheck, checkmember, 'Cioui:Inspector:boolean');
                    self.lines.push(valueunitcheck);
                    break;

                case InspectorInputType.VALUE_AND_FIXEDUNIT:
                    var valueunitfixed = target.addValueUnitFixed(label, "", unit, tooltip);
                    connectVisibility(valueunitfixed, element);
                    addInteractionTextField(valueunitfixed, datamember, unitmember, element.datatype, [], element.update_while_typing, readOnly, disabled);
                    if(unitmember) addInteraction(valueunitfixed, unitmember, 'Cioui:Inspector:unit');
                    self.lines.push(valueunitfixed);
                    break;

                case InspectorInputType.CHECKBOX:
                    var checkbox = target.addCheckbox(label, value, tooltip, readOnly);
                    connectVisibility(checkbox, element);
                    addInteraction(checkbox, datamember, 'Cioui:Inspector:boolean');
                    self.lines.push(checkbox);
                    break;

                case InspectorInputType.SELECTBOX:
                    var selectbox = target.addSelectbox(label, [], tooltip, readOnly);
                    connectVisibility(selectbox, element);
                    connectSelectboxOptions(selectbox, element);
                    selectbox.setValue(datamember());
                    addInteraction(selectbox, datamember, 'Cioui:Inspector:value');
                    self.lines.push(selectbox);
                    break;

                case InspectorInputType.SELECTBOXEVENT:
                    var selectbox = target.addSelectbox(label, [], tooltip, readOnly);
                    connectVisibility(selectbox, element);
                    connectSelectboxOptions(selectbox, element);
                    selectbox.setValue(element.init);
                    connectSelectboxEvent(selectbox, element);
                    self.lines.push(selectbox);
                    break;

                case InspectorInputType.BUTTON:
                    var button = addButton(target, element);
                    connectVisibility(button, element);
                    self.lines.push(button);
                    break;

                case InspectorInputType.BUTTON_GROUP:
                    var buttonGroup = target.addButtonGroup();
                    connectVisibility(buttonGroup, element);
                    if (element.buttons) {
                        element.buttons.forEach(function(buttonElement) {
                            if (buttonElement.clickAction) {
                                buttonElement.cEvent = buttonElement.clickAction();
                            }
                            var btn = addButton(buttonGroup, buttonElement);
                            if(buttonElement.disable){
                                btn.disable();
                            }
                        });
                    }
                    self.lines.push(buttonGroup);
                    break;

                case InspectorInputType.SLIDER:
                    var sliderMin = element.sliderMin;
                    var sliderMax = element.sliderMax;
                    var sliderStep = element.sliderStep;
                    var slider = target.addSlider(label, value, sliderMin, sliderMax, sliderStep, tooltip);
                    connectVisibility(slider, element);
                    addInteractionTextField(slider, datamember, unitmember, element.datatype, [], element.update_while_typing, readOnly, disabled);
                    addInteraction(slider, datamember, 'Cioui:Inspector:value');
                    self.lines.push(slider);
                    break;

                case InspectorInputType.SKETCH2D:
                    var sketch2d = target.addSketch2D(200, 200);
                    connectVisibility(textinput, element);
                    sketch2d.value = datamember();
                    addInteraction(sketch2d, datamember, 'Cioui:Inspector:value');
                    self.lines.push(sketch2d);
                    break;

                //add a row in inspector group
                //currently row can contain LABEL and VALUE_AND_FIXEDUNIT type inspector elements.
                //TODO: need to decide on which inspector type can be added in future.
                //TODO: do not use whole switch statements may be?
                case InspectorInputType.ROW:
                    var row = target.addRow(element.notFlexContainer);
                    connectVisibility(row, element);
                    self.addElements(element.items, row, readOnlyMode);
                    self.lines.push(row);
                    break;

                default:
                    console.error("Inspector item has no valid type");
            }
        }
    });
};

// the formatter is what changes the data to something viewable
var floatFormatter = function(val, unit) {
    var str = (unit && unit())? " "+unit() : "";
    if(val != "")   //allow "" in case of multi selection
        return Math.round(val * 100) / 100 + str;
    else
        return val + str;
};


var isValid = function(val) {
    if(typeof val != "string" && isNaN(val)){
        return false;
    } else if(val === null){
        return false;
    } else {
        return true;
    }
};
